import React from 'react';
import { concatClassName } from '@dateam/ark-react';
import propTypes from 'prop-types';
import styles from './Page.module.scss';

type Props = {
    className?: string;
    children?: React.ReactNode;
};

const PageTitle: React.FC<Props> = ({
    className,
    children
}: Props) => (
    <h1 className={concatClassName(styles['title'], className)}>
        {children}
    </h1>
);

PageTitle.propTypes = {
    className: propTypes.string,
    children: propTypes.node
};

PageTitle.defaultProps = {
    className: undefined,
    children: undefined
};

export default PageTitle;
